import React from 'react';
import PropTypes from 'prop-types';

import MetaList from '../MetaList/MetaList';
import MetaListItem from '../MetaList/MetaListItem';
import CustomerInfoSection from './CustomerInfoSection';
import NoInsurances from '../NoInsurances';

export default class CoInsuredInfo extends React.Component {
    static propTypes = {
        title: PropTypes.string,
        description: PropTypes.string,
        name: PropTypes.string,
        personalIdentityNumber: PropTypes.string,
        customerSupportUrl: PropTypes.string,
        modifierClass: PropTypes.array,
        hasRegisteredInsurances: PropTypes.bool
    }

    static defaultProps = {
        title: '',
        description: '',
        name: '',
        personalIdentityNumber: '',
        customerSupportUrl: '#',
        modifierClass: [],
        hasRegisteredInsurances: true
    };

    render() {
        const helpText = (<span>Om du har några frågor, eller om du sedan tidigare har en registrerad medförsäkrad och vill byta till en ny <br />medförsäkrad, kontakta kundservice på 0771-21 09 09.</span>);
        const unknownCoinsured = this.props.name.indexOf('Okänd ') === 0;

        const unknownCoinsuredText = (
            <span>
                Vi saknar uppgifter om din medförsäkrade. Kontakta kundservice på <a className="inline-phone-link" href="tel:0771210909">0771-21 09 09</a> för att lämna dessa.
            </span>
        );
        const noCoinsuredText = 'Du har ingen registrerad medförsäkrad';
        
        return (
            <CustomerInfoSection
                title={this.props.title}
                description={this.props.description}
            >
                {this.props.personalIdentityNumber && <MetaList>
                    { !this.props.hasRegisteredInsurances &&
                        <span className="member-info-section__content__coinsured-no-insurances">
                            Nedan person är registrerad som din medförsäkrade men saknar just nu försäkringar. Om du vill uppdatera dina uppgifter så kontakta kundservice på <a href="tel:+46771210909">0771-21 09 09</a>.
                            <br />
                            { /* TODO: fetch link url from api */ }
                            <a href="/mina-sidor/teckna-forsakring/">Teckna försäkringar för medförsäkrad</a>
                        </span>
                    }
                    <MetaListItem
                        helpText={helpText}
                        helpTextActionLabel={'Kontakta kundtjänst'}
                        helpTextActionUrl={this.props.customerSupportUrl}
                        title={this.props.name}
                    />
                    <MetaListItem
                        contents={[
                            this.props.personalIdentityNumber,
                        ]}
                    />
                </MetaList>}
                {!this.props.personalIdentityNumber && <NoInsurances>
                    {unknownCoinsured ? unknownCoinsuredText : noCoinsuredText}
                </NoInsurances>}
            </CustomerInfoSection>
        );
    }
};